import { render, staticRenderFns } from "./SingleLayerMainInfos.vue?vue&type=template&id=ad2a1ba4&scoped=true"
import script from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
export * from "./SingleLayerMainInfos.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerMainInfos.vue?vue&type=style&index=0&id=ad2a1ba4&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "ad2a1ba4",
  null
  ,true
)

export default component.exports